import { getAnalytics, logEvent as LogFirebaseEvent } from 'firebase/analytics'
import smartlookClient from 'smartlook-client'

declare global {
  interface Window {
    Cookiebot?: {
      consent?: {
        statistics?: boolean
      }
    }
  }
}

type AnalyticEvent = { name: string; params?: { [key: string]: any } }

const CONSENT_REQUIRED_EVENTS = new Set<string>([
  'utm_conversion',
  'gb_experiment_impression',
  'redirect_experiment_impression',
])

const eventQueue: AnalyticEvent[] = []
let isCookieConsentListenerInitialized = false

const isCookieConsentAccepted = () => {
  if (typeof window === 'undefined') {
    return false
  }

  return !!window.Cookiebot?.consent?.statistics
}

const logFirebaseAndSmartlookEvent = (
  name: string,
  params?: { [key: string]: any }
) => {
  LogFirebaseEvent(getAnalytics(), name, params)
  smartlookClient.track(name, params || {})
}

export const logEvent = (name: string, params?: { [key: string]: any }) => {
  if (CONSENT_REQUIRED_EVENTS.has(name)) {
    if (isCookieConsentAccepted()) {
      void logFirebaseAndSmartlookEvent(name, params)
    } else {
      eventQueue.push({ name, params })
      if (!isCookieConsentListenerInitialized) {
        window.addEventListener(
          'CookiebotOnAccept',
          () => {
            while (eventQueue.length) {
              const eventToProcess = eventQueue.shift()
              if (!eventToProcess) {
                continue
              }

              void logFirebaseAndSmartlookEvent(
                eventToProcess.name,
                eventToProcess.params
              )
            }
          },
          { once: true }
        )
        isCookieConsentListenerInitialized = true
      }
    }
  } else {
    void logFirebaseAndSmartlookEvent(name, params)
  }
}
